// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"5605a03f","176":"a76abd3d","253":"3ed4142d","390":"77505252","427":"9b14d45f","452":"356e1a63","535":"0edc9916","634":"13e003e1","673":"84dd08c6","720":"644b5879","984":"e5f9730a"}[chunkId] + ".chunk.js";
};